import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=0553e1b5"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=0553e1b5&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3276139710/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0553e1b5')) {
      api.createRecord('0553e1b5', component.options)
    } else {
      api.reload('0553e1b5', component.options)
    }
    module.hot.accept("./SideBar.vue?vue&type=template&id=0553e1b5", function () {
      api.rerender('0553e1b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layouts/Partials/SideBar.vue"
export default component.exports